module.exports = __webpack_public_path__ + "static/media/excelZendy.f2f3bd91.png";